"use strict";

var		// Regular Expression Patterns
	_RANGE_0_100 = '(\\d{1,2}|100)'
	, _RANGE_0_255 = '(2([0-4]\\d|5[0-5])|([01]?\\d{1,2}))'
	, _RANGE_0_1 = '(0?\\.\\d{1,2}|[01])'
	, _RANGE_0_360 = '(3(([0-5]\\d)|60)|([12]?\\d{1,2}))'

	// Numeric Ranges
	, PATTERN_RANGE_0_100 = new RegExp('^' + _RANGE_0_100 + '$')
	, PATTERN_RANGE_0_255 = new RegExp('^' + _RANGE_0_255 + '$')
	, PATTERN_RANGE_0_1 = new RegExp('^' + _RANGE_0_1 + '$')
	, PATTERN_ANGLE = new RegExp('^\\-?' + _RANGE_0_360 + '$')

	// Color Formats
	, PATTERN_COLOR_HEX = /^#([a-f0-9]{3}){1,2}$/i
	, PATTERN_COLOR_RGB = new RegExp('^rgb\\(((' + _RANGE_0_255 + ',){2}' + _RANGE_0_255 + '|(' + _RANGE_0_100 + '%,){2}' + _RANGE_0_100 + '%)\\)$')
	, PATTERN_COLOR_RGBA = new RegExp('^rgba\\(((' + _RANGE_0_255 + ',){3}|(' + _RANGE_0_100 + '%,){3})' + _RANGE_0_1 + '\\)$')

	, PATTERN_FONT_SIZE_PX = /^[1-9]\d?(px)?$/

	/*
	 * -/+ Integer or Float value
	 * It can have optional space before and/or after it
	 */
	, NUMERIC = '\\u0020*?\\-?\\d+(\\.\\d+)?\\u0020*?'

	/*
	 * SVG Coordinates seperator
	 * It can be <space> or comma (,)
	 */
	, SEPARATOR = '[\\u0020,]'

	// Variable to improve Path Regex readability
	, _path_cord = NUMERIC + SEPARATOR + NUMERIC

	// SVG Path "d" Attribute value Format
	, PATTERN_SVG_PATH = new RegExp('^(m' + _path_cord + ')(([ltm]' + _path_cord + ')|([hv]' + NUMERIC + ')|(c' + _path_cord + SEPARATOR + NUMERIC + SEPARATOR
		+ _path_cord + SEPARATOR + NUMERIC + ')|([sq]' + _path_cord + SEPARATOR + _path_cord + ')|(a' + _path_cord
		+ SEPARATOR + '\\-?' + _RANGE_0_360 + SEPARATOR + '[01]' + SEPARATOR + '[01]' + SEPARATOR + _path_cord + '))+z?$', 'i')

	// Valid Line Styles
	, LINE_STYLES = ['dash', 'dashdotdot', 'dotted', 'solid']
	// Valid font-weight values
	, FONT_WEIGHTS = ['normal', 'bold']
	// Valid font-style values
	, FONT_STYLES = ['normal', 'italic']
	// Valid font-style values
	, TEXT_ANCHORS = ['start', 'middle', 'end']
	// Valid Fill Styles
	, FILL_STYLES = ['none', 'solid']
	// Valid Point Styles
	, POINT_STYLES = ['circle', 'cross', 'diamond', 'path', 'square', 'triangle-down', 'triangle-up']
	;

/*
 * Initialize Validator Factory Object
 */
var validator = {};

/*
 * Private functions definitions
 */

/*
 * To test if given value is string
 *  
 * @params		str
 * @returns		true | false
 */
function _isString(str) {
	return typeof str === 'string';
}

/*
 * To test if given value is Boolean
 *  
 * @params		val
 * @returns		true | false
 */
function _isBoolean(val) {
	return typeof val === 'boolean';
}

/*
 * To test if given value is number
 *  
 * @params		number
 * @returns		true | false
 */
function _isNumber(number) {
	return $.isNumeric(number);
}

/*
 * To test if given value exists in given array
 *  
 * @params		val
 * @params		arr	{Array}
 * @returns		true | false
 */
function _inArray(val, arr) {
	return $.inArray(val, arr) != -1;
}

/*
 * To test if given value is an JS array
 *  
 * @params		arr	{Array}
 * @returns		true | false
 */
function _isArray(arr) {
	return $.isArray(arr);
}

/*
 * To test if given value is a non-empty JS Object
 *  
 * @params		obj	{Object}
 * @returns		true | false
 */
function _isDataObject(obj) {

	if ((obj instanceof Object) && !(obj instanceof Array) && (typeof obj !== 'function')) {

		for (var key in obj) {

			if (obj.hasOwnProperty(key)) return true;
		}
	}
	return false;
}

/*
 * To test if given value is a RGB or RGBA array
 *  
 * @params		colorArray	{Array}
 * @returns		true | false
 */
function _isColorArray(colorArray) {

	//If color value is passed as RGBA array of length 3 or 4
	if (_isArray(colorArray)) {

		if (colorArray.length != 3 && colorArray.length != 4) {
			return false;
		}

		for (var i = 0; i < 3; i++) {
			if (!PATTERN_RANGE_0_255.test(colorArray[i])) {
				return false;
			}
		}
		/*
		 * Next line will be executed only if 1st 3 array elements are valid
		 * Hence, result depends on last element of array if provided
		 */
		return colorArray[3] !== undefined ? PATTERN_RANGE_0_1.test(colorArray[3]) : true;
	}
}

/*
 * To test if given value is a hexadecimal color string
 *  
 * @params		color	{String}
 * @returns		true | false
 */
function _isHexColor(color) {

	return PATTERN_COLOR_HEX.test(color);
}

/*
 * To test if given value is a RGB color string
 *  
 * @params		color	{String}
 * @returns		true | false
 */
function _isRgbColor(color) {

	return PATTERN_COLOR_RGB.test(color);
}

/*
 * To test if given value is a RGBA color string
 *  
 * @params		color	{String}
 * @returns		true | false
 */
function _isRgbaColor(color) {

	return PATTERN_COLOR_RGBA.test(color);
}

/*
 * To test if given color is valid
 *  
 * @params		colorValue {String | Array}
 * @returns		true | false
 */
function _isValidColor(colorValue) {

	//If color value is passed as RGBA array of length 4
	if (_isArray(colorValue)) {

		if (colorValue.length != 3 && colorValue.length != 4) {
			return false;
		}

		for (var i = 0; i < 3; i++) {
			if (!PATTERN_RANGE_0_255.test(colorValue[i])) {
				return false;
			}
		}
		/*
		 * Next line will be executed only if 1st 3 array elements are valid
		 * Hence, result depends on last element of array if provided
		 */
		return colorValue[3] !== undefined ? PATTERN_RANGE_0_1.test(colorValue[3]) : true;
	}
	// If color value is a string 
	else if (_isString(colorValue)) {
		// Remove all the spaces from the color string 
		var _color = colorValue.replace(/\s*?/g, '');

		// convert the color string to lower case
		_color = _color.toLowerCase();

		// If color value is in #abcdef Format
		if (_color.indexOf('#') == 0) {

			return PATTERN_COLOR_HEX.test(_color);
		}
		// If color value is in rgba(255,255,255, 1) Format
		else if (_color.indexOf('rgba') == 0) {

			return PATTERN_COLOR_RGBA.test(_color);
		}
		// If color value is in rgb(255,255,255) format
		else if (_color.indexOf('rgb') == 0) {

			return PATTERN_COLOR_RGB.test(_color);
		}
	}
	// If any other color format
	return false;
}

/*
 * To test if given value is valid border string 
 *  
 * @params		styleValue {String}		border style value
 * @returns		true | false
 */
function _isValidLineStyle(styleValue) {

	if (!_isString(styleValue)) {

		return false;
	}

	return _inArray(styleValue, LINE_STYLES);
}

/*
 * To test if given value is positive and greater than 0  
 *  
 * @params		number {Number}		numeric value
 * @returns		true | false
 */
function _isPositiveNumber(number) {

	if (_isNumber(number)) {

		return eval(number) >= 0;
	}

	return false;
}

/*
 * To test if given value is valid angle 
 *  
 * @params		angle {Number}
 * @returns		true | false
 */
function _isValidAngle(angle) {

	if (_isNumber(angle)) {

		return PATTERN_ANGLE.test(angle);
	}

	return false;
}

/*
 * To test if given value is leser than the given limit
 *  
 * @params		value {Number}
 * @params		limit {Number}
 * @returns		true | false
 */
function _isValidMin(value, limit) {

	if (_isNumber(value)) {
		return value >= limit;
	}

	return false;
}

/*
 * To test if given value is valid font-weight 
 *  
 * @params		value {String}
 * @returns		true | false
 */
function _isValidFontWeight(value) {

	return _inArray(value, FONT_WEIGHTS);
}

/*
 * To test if given value is valid font-style 
 *  
 * @params		value {String}
 * @returns		true | false
 */
function _isValidFontStyle(value) {

	return _inArray(value, FONT_STYLES);
}

/*
 * To test if given value is valid font-size 
 *  
 * @params		size {Number | String}
 * @returns		true | false
 */
function _isValidFontSize(size) {

	return PATTERN_FONT_SIZE_PX.test(size);
}

/*
 * To test if given value is valid text alignment
 *  
 * @params		alignment {String}
 * @returns		true | false
 */
function _isValidAnchor(alignment) {

	return _inArray(alignment, TEXT_ANCHORS);
}

/*
 * To test if given value is valid Fill Styles
 *  
 * @params		style {String}
 * @returns		true | false
 */
function _isValidFillStyle(style) {

	return _inArray(style, FILL_STYLES);
}

/*
 * To test if given value is valid Point Styles
 *  
 * @params		style {String}
 * @returns		true | false
 */
function _isValidPointStyle(style) {

	return _inArray(style, POINT_STYLES);
}

/*
 * To test if given value is valid SVG Path
 *  
 * @params		path {String}
 * @returns		true | false
 */
function _isValidSvgPath(path) {

	return PATTERN_SVG_PATH.test(path);
}

/*
 * To test if given value is valid 2-Dimensional Array
 *  
 * @params		path {Array}
 * @returns		true | false
 */
function _isSvgPathArray(path) {

	if (_isArray(path) && path.length >= 1) {

		for (var i = 0; i < path.length; i++) {

			if (_isArray(path[i]) && path[i].length >= 2) {

				for (var j = 0; j < path[i].length; j++) {

					if (!_isArray(path[i][j]) || path[i][j].length != 2) {

						return false;
					}
				}
			}
		}
		return true;
	}
	return false;
}

/*
 * To test if given value is opacity
 *  
 * @params		opacity {String}
 * @returns		true | false
 */
function _isOpacity(opacity) {

	return PATTERN_RANGE_0_1.test(opacity);
}

/*
 * To test if given value is valid Fill Styles
 *  
 * @params		instance {Object}
 * @params		className {Class | Function} 
 * @returns		true | false
 */
function _isInstanceOf(instance, className) {

	return instance && instance instanceof className;
}

/**
 * validate a given value against a list of valid values
 * @param value {Object} a value object
 * @param type {String} value type
 * @param oValidValues {Object} a key-value pair object that contains all valid values
 * @return {Boolean} true if the value is valid; false otherwise.
 */
function _isValidValue(value, type, oValidValues) {
	var result = false;

	for (var key in oValidValues) {
		if (oValidValues.hasOwnProperty(key) && key.indexOf(type) > -1 && oValidValues[key] === value) {
			return true;
		}
	}

	return false;
}


/*
 * Assign functions to be made public to validator Object
 */
module.exports = {
	'inArray': _inArray,
	'isArray': _isArray,
	'isBoolean': _isBoolean,
	'isColorArray': _isColorArray,
	'isDataObject': _isDataObject,
	'isHexColor': _isHexColor,
	'isInstanceOf': _isInstanceOf,
	'isNumber': _isNumber,
	'isOpacity': _isOpacity,
	'isPositiveNumber': _isPositiveNumber,
	'isRgbColor': _isRgbColor,
	'isRgbaColor': _isRgbaColor,
	'isString': _isString,
	'isSvgPathArray': _isSvgPathArray,
	'isValidAnchor': _isValidAnchor,
	'isValidAngle': _isValidAngle,
	'isValidColor': _isValidColor,
	'isValidFillStyle': _isValidFillStyle,
	'isValidFontSize': _isValidFontSize,
	'isValidFontStyle': _isValidFontStyle,
	'isValidFontWeight': _isValidFontWeight,
	'isValidLineStyle': _isValidLineStyle,
	'isValidMin': _isValidMin,
	'isValidPointStyle': _isValidPointStyle,
	'isValidSvgPath': _isValidSvgPath,
	'isValidValue': _isValidValue
};


